(() => {
  const DESKTOP = window.matchMedia('(min-width: 768px)');
  const REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)');

  const step = (viewport, direction) => {
    const slides = viewport.querySelectorAll('.lp-slider__slide');
    if (!slides.length) return;

    const pitch =
      slides.length > 1
        ? slides[1].offsetLeft - slides[0].offsetLeft
        : slides[0].getBoundingClientRect().width;

    viewport.scrollBy({ left: pitch * direction, behavior: REDUCED.matches ? 'auto' : 'smooth' });
  };

  const syncArrows = (kit) => {
    const viewport = kit.querySelector('.lp-kits__viewport');
    const prev = kit.querySelector('.lp-kits__arrow--prev');
    const next = kit.querySelector('.lp-kits__arrow--next');
    if (!viewport || !prev || !next) return;

    const max = viewport.scrollWidth - viewport.clientWidth;
    prev.disabled = viewport.scrollLeft <= 1;
    next.disabled = viewport.scrollLeft >= max - 1;
  };

  const syncSemantics = (kits) => {
    kits.forEach((kit) => {
      const toggle = kit.querySelector('.lp-kits__title-btn');
      if (!toggle) return;

      if (DESKTOP.matches) {
        toggle.setAttribute('aria-expanded', kit.hasAttribute('data-active') ? 'true' : 'false');
      } else {
        toggle.removeAttribute('aria-expanded');
      }
    });
  };

  const init = (root) => {
    if (root.hasAttribute('data-ready')) return;

    const kits = Array.from(root.querySelectorAll('.lp-kits__kit'));
    if (!kits.length) return;

    const activate = (kit) => {
      kits.forEach((other) => other.toggleAttribute('data-active', other === kit));
      syncSemantics(kits);
      syncArrows(kit);
    };

    kits.forEach((kit, index) => {
      const viewport = kit.querySelector('.lp-kits__viewport');
      const toggle = kit.querySelector('.lp-kits__title-btn');
      const prev = kit.querySelector('.lp-kits__arrow--prev');
      const next = kit.querySelector('.lp-kits__arrow--next');

      kit.toggleAttribute('data-active', index === 0);

      if (toggle) toggle.addEventListener('click', () => activate(kit));

      if (viewport) {
        viewport.addEventListener('scroll', () => syncArrows(kit), { passive: true });
        if (prev) prev.addEventListener('click', () => step(viewport, -1));
        if (next) next.addEventListener('click', () => step(viewport, 1));
        if ('ResizeObserver' in window) {
          new ResizeObserver(() => syncArrows(kit)).observe(viewport);
        }
      }

      syncArrows(kit);
    });

    DESKTOP.addEventListener('change', () => syncSemantics(kits));
    syncSemantics(kits);

    root.addEventListener('shopify:block:select', (event) => {
      const target = event.target;
      const kit = target.closest('.lp-kits__kit') || target.querySelector('.lp-kits__kit');
      if (kit) activate(kit);
    });

    root.setAttribute('data-ready', '');
  };

  const initAll = (scope) => {
    if (scope instanceof Element && scope.matches('.lp-kits')) init(scope);
    scope.querySelectorAll('.lp-kits').forEach(init);
  };

  initAll(document);

  document.addEventListener('shopify:section:load', (event) => {
    if (event.target instanceof Element) initAll(event.target);
  });
})();

(() => {
  const inputFor = (slot) =>
    slot ? document.querySelector(`[data-lp-kit-input][data-slot="${slot}"]`) : null;

  const sync = () => {
    document.querySelectorAll('[data-lp-kit-add]').forEach((button) => {
      const input = inputFor(button.dataset.slot);
      const selected = Boolean(input && input.checked);

      button.hidden = !input;
      button.toggleAttribute('data-selected', selected);
      const label = button
  .closest('.lp-kits__add-container')
  ?.querySelector('.lp-kits__add-label');

if (label) {
  label.textContent = selected ? 'Added ✓' : 'Add to Cart';
}
      button.setAttribute(
        'aria-label',
        selected ? button.dataset.labelRemove : button.dataset.labelAdd
      );
    });
  };

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;

    const button = event.target.closest('[data-lp-kit-add]');
    if (!button) return;

    const input = inputFor(button.dataset.slot);
    if (input) input.click();
  });

  document.addEventListener('change', (event) => {
    if (event.target instanceof Element && event.target.matches('[data-lp-kit-input]')) sync();
  });

  document.addEventListener('shopify:section:load', sync);

sync();

requestAnimationFrame(sync);
window.addEventListener('load', sync, { once: true });
})();
